import { saveAs } from "file-saver";

const DownloadUtils = {
  /**
   * ファイルをダウンロードする汎用メソッド
   * @param {Blob | String} data - ダウンロード対象データ（Blobまたは文字列）
   * @param {String} fileName - 保存するファイル名
   * @param {String} mimeType - ファイルのMIMEタイプ（デフォルト：'application/octet-stream'）
   */
  downloadFile(data, fileName, mimeType = "application/octet-stream") {
    let blob;

    if (typeof data === "string") {
      // 文字列データの場合、Blobを生成
      blob = new Blob([data], { type: mimeType });
    } else if (data instanceof Blob) {
      // Blobデータをそのまま使用
      blob = data;
    } else {
      console.error("Invalid data type for download");
      return;
    }

    saveAs(blob, fileName);
  },

  /**
   * CSVデータをダウンロード
   * @param {Array} csvContent - CSVのデータ行（String）
   * @param {String} fileName - 保存するファイル名
   */
  downloadCSV(csvContent, fileName) {
    this.downloadFile(csvContent, fileName, "text/csv");
  },

  /**
   * Excelデータをダウンロード
   * @param {Blob} excelBlob - ExcelファイルのBlobデータ
   * @param {String} fileName - 保存するファイル名
   */
  downloadExcel(excelBlob, fileName) {
    this.downloadFile(
      excelBlob,
      fileName,
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
  },

  /**
   * PDFデータをダウンロード
   * @param {Blob} pdfBlob - PDFファイルのBlobデータ
   * @param {String} fileName - 保存するファイル名
   */
  downloadPDF(pdfBlob, fileName) {
    this.downloadFile(pdfBlob, fileName, "application/pdf");
  },
};

export default DownloadUtils;
